import axios from "axios";
import { IP } from "../index.js";

// 查询页面配置
export async function selectConfig() {
  var resp = await axios.post(`${IP}/admin/pageConfig/selectAll`, {});
  return resp.data;
}
// 修改页面配置
export async function updateConfig(data) {
  var resp = await axios.post(`${IP}/admin/pageConfig/update`, {
    ...data,
  });
  return resp.data;
}
